export default __webpack_public_path__ + "static/media/switch-on.88d10ee7.mp3";